import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { Observable } from 'rxjs';

import { DashboardService } from '../services/dashboard.service';
import { DashboardModel } from 'app/models/dashboard.model';

@Injectable()
export class DashboardResolver  {

    constructor(private dashboard_service: DashboardService)
    {

    }

    resolve(route: ActivatedRouteSnapshot): Observable<DashboardModel> {
        return this.dashboard_service.GetDashboard();
  }
}
